module.exports = __webpack_public_path__ + "static/media/vena.52d62378.jpeg";